import React from 'react'
import './Logo.scss'

export default () => (
  <div
    className="Logo"
    style={{
      backgroundImage: `url(/images/logo-one-line.svg)`
    }}
  />
)
